import React, { Fragment } from "react"
import { Popover, Transition } from "@headlessui/react"
import { motion } from "framer-motion"
import Arrow from "./icons/arrow"
import "../css/dropdown.css"
import LocalizedLink from "./localized-link"

export function Dropdown({ options, placeholder, theme = "light" }) {
  // let timeout // NodeJS.Timeout
  // const timeoutDuration = 10

  // const buttonRef = useRef(null) // useRef<HTMLButtonElement>(null)
  // const [openState, setOpenState] = useState(false)

  // const toggleMenu = open => {
  //   // log the current open state in React (toggle open state)
  //   setOpenState(openState => !openState)
  //   // toggle the menu by clicking on buttonRef
  //   buttonRef?.current?.click() // eslint-disable-line
  // }

  // Open the menu after a delay of timeoutDuration
  // const onHover = (open, action) => {
  //   // if the modal is currently closed, we need to open it
  //   // OR
  //   // if the modal is currently open, we need to close it
  //   if (
  //     (!open && !openState && action === "onMouseEnter") ||
  //     (open && openState && action === "onMouseLeave")
  //   ) {
  //     // clear the old timeout, if any
  //     clearTimeout(timeout)
  //     // open the modal after a timeout
  //     timeout = setTimeout(() => toggleMenu(open), timeoutDuration)
  //   }
  //   // else: don't click! 😁
  // }

  // const handleClick = open => {
  //   setOpenState(!open) // toggle open state in React state
  //   clearTimeout(timeout) // stop the hover timer if it's running
  // }

  // const handleClickOutside = event => {
  //   if (buttonRef.current && !buttonRef.current.contains(event.target)) {
  //     event.stopPropagation()
  //   }
  // }
  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside)

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside)
  //   }
  // })
  return (
    <div className="flex items-center justify-start">
      <Popover>
        {({ open }) => (
          <div className="relative font-normal print:hidden">
            <Popover.Button
              // onMouseEnter={() => onHover(open, "onMouseEnter")}
              // onKeyDown={() => onHover(open, "onMouseEnter")}
              // onMouseLeave={() => onHover(open, "onMouseLeave")}
              // onKeyUp={() => onHover(open, "onMouseLeave")}
              className={`${
                theme === "light"
                  ? "mx-auto hover:bg-blue-50 text-left bg-white px-6 py-4 transition rounded-md w-64 max-w-full cursor-pointer"
                  : ""
              }`}
            >
              <div
                // onClick={() => handleClick(open)}
                // onKeyDown={() => handleClick(open)}
                className="flex justify-between items-center w-full space-x-3 leading-snug"
              >
                <span className="font-bold text-navy">{placeholder}</span>
                <Arrow className="text-bright-blue w-2" />
              </div>
            </Popover.Button>
            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                static
                className={`z-30 absolute overflow-visible transform w-64 pt-4 -translate-x-1/2 left-1/2 ${
                  theme === "light" ? "" : "sm:translate-x-0 sm:left-0"
                }`}
              >
                <motion.ol
                  className={`relative origin-top overflow-visible transform bg-white rounded dropdown py-4 shadow-spread`}
                  initial={{
                    opacity: 0,
                    scale: 0.7,
                    rotateX: "-90deg",
                    height: 0,
                  }}
                  animate={{
                    opacity: 1,
                    scale: 1,
                    rotateX: "0deg",
                    height: "auto",
                  }}
                  exit={{
                    opacity: 0,
                    scale: 0.7,
                    rotateX: "-90deg",
                    height: 0,
                  }}
                  transition={{ duration: 0.15 }}
                >
                  {options?.map(option => {
                    const link = option?.item
                    return (
                      <li key={link?.url} className={`text-navy`}>
                        <LocalizedLink
                          to={link?.url}
                          target={link?.target}
                          className="leading-snug block px-6 py-3 text-navy hover:text-navy hover:bg-blue-50 focus:text-navy focus:bg-blue-50"
                        >
                          {link?.title}
                        </LocalizedLink>
                      </li>
                    )
                  })}
                </motion.ol>
              </Popover.Panel>
            </Transition>
          </div>
        )}
      </Popover>
      <ol className="hidden print:block">
        {options?.map(({ option }) => {
          return (
            <li key={option} className={`py-1`}>
              <a
                href={option?.url}
                target={option?.target}
                className="block py-1 font-light"
              >
                {option?.title}
              </a>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
